(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/game-guide/assets/javascripts/constants.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/game-guide/assets/javascripts/constants.js');
"use strict";

var _gameGuideConfig$game, _gameGuideConfig$game2, _gameGuideConfig$favo, _gameGuideConfig$favo2, _gameGuideConfig$cash, _gameGuideConfig$cash2;

const {
  gameGuideConfig
} = svs.oddset_kambi.data;
const {
  tabsConfig
} = svs.oddset_kambi.data;
const {
  MenuTabTypes
} = svs.oddset_kambi.components.common.constants;
const gameGuideRoutes = [{
  path: '/',
  article: null,
  logotypeAltText: (tabsConfig === null || tabsConfig === void 0 ? void 0 : tabsConfig.find(tab => (tab === null || tab === void 0 ? void 0 : tab.tabType) === MenuTabTypes.GameGuide).logotypeAltText) || 'Oddset',
  label: 'Så funkar Oddset'
}, {
  path: '/spelformer',
  article: (_gameGuideConfig$game = gameGuideConfig.gameFormsArticle) === null || _gameGuideConfig$game === void 0 ? void 0 : _gameGuideConfig$game.article,
  logotypeAltText: (_gameGuideConfig$game2 = gameGuideConfig.gameFormsArticle) === null || _gameGuideConfig$game2 === void 0 ? void 0 : _gameGuideConfig$game2.logotypeAltText,
  label: 'Spelformer'
}, {
  path: '/favoriter',
  article: (_gameGuideConfig$favo = gameGuideConfig.favoritesArticle) === null || _gameGuideConfig$favo === void 0 ? void 0 : _gameGuideConfig$favo.article,
  logotypeAltText: (_gameGuideConfig$favo2 = gameGuideConfig.favoritesArticle) === null || _gameGuideConfig$favo2 === void 0 ? void 0 : _gameGuideConfig$favo2.logotypeAltText,
  label: 'Favoriter'
}, {
  path: '/cash-out',
  article: (_gameGuideConfig$cash = gameGuideConfig.cashOutArticle) === null || _gameGuideConfig$cash === void 0 ? void 0 : _gameGuideConfig$cash.article,
  logotypeAltText: (_gameGuideConfig$cash2 = gameGuideConfig.cashOutArticle) === null || _gameGuideConfig$cash2 === void 0 ? void 0 : _gameGuideConfig$cash2.logotypeAltText,
  label: 'Cash Out'
}];
setGlobal('svs.oddset_kambi.components.game_guide.constants', {
  gameGuideRoutes
});

 })(window);